import template from './sw-cms-el-preview-acris-blog-subtitle.html.twig';
import './sw-cms-el-preview-acris-blog-subtitle.scss';

const { Component } = Shopware;

Component.register('sw-cms-el-preview-acris-blog-subtitle', {
    template
});